var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.045 6.96548C21.2728 2.98685 17.8321 0 13.6988 0C10.4171 0 7.56684 1.89129 6.14742 4.65903C2.72943 5.02806 0.0722656 7.96879 0.0722656 11.5323C0.0722656 15.3494 3.12687 18.4516 6.88552 18.4516H21.6476C24.7817 18.4516 27.3253 15.8684 27.3253 12.6855C27.3253 9.64097 24.9974 7.17306 22.045 6.96548ZM21.6476 16.1452H6.88552C4.37597 16.1452 2.34335 14.0809 2.34335 11.5323C2.34335 8.98363 4.37597 6.91935 6.88552 6.91935H7.69175C8.44121 4.2554 10.8372 2.30645 13.6988 2.30645C17.1508 2.30645 19.9443 5.14339 19.9443 8.64919V9.22581H21.6476C23.5326 9.22581 25.0542 10.7711 25.0542 12.6855C25.0542 14.5998 23.5326 16.1452 21.6476 16.1452Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.c682c41a610978f517dfd43faca59ec4.svg";
export { ForwardRef as ReactComponent };